import React from 'react';
import { useSelector } from 'react-redux';
import Step from './components/Step';
import selectSteps from './timeline-selectors';
var Timeline = function () {
    var steps = useSelector(selectSteps());
    return (React.createElement("div", { className: 'timeline' }, steps.map(function (step) { return (React.createElement(Step, { key: "timeline_step_".concat(step.header), header: step.header, content: step.content, title: step.title })); })));
};
export default Timeline;
